import React from "react";
import _ from "lodash";
import '../../components/report/report.css'
import { Skeleton } from "primereact/skeleton";

const SkeletonView = () => {
    return (
        <div>
            <div className="skeletonWrapper">
                <div className="report">
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                </div>
                <div className="report">
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                </div>
            </div>
            <div className="skeletonWrapper">
                <div className="report">
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                </div>
                <div className="report">
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                </div>
                {/* <div className="report">
                    <Skeleton shape="circle" size="16rem"></Skeleton>
                </div> */}
            </div>
            <div className="skeletonWrapper">
            <div className="report">
                    <Skeleton shape="circle" size="16rem"></Skeleton>
                </div>
                {/* <div className="report">
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                    <Skeleton width="50px" height="162px" size="50px"></Skeleton>
                </div> */}
            </div>

        </div>
    );
};
export default SkeletonView;
